export default {
  recommendedTag: {
    id: 'insurance_offers_recommended_tag',
    defaultMessage: 'Recommended',
  },
}
